// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-selector-language-group {
  display: flex;
  width: 100%;
  border: 1px solid var(--gray);
  border-radius: 4px;
}
.topic-selector-language-group:focus-within {
  border-color: var(--color_primary_500);
}
.topic-selector-language-group .language-selector {
  border: none;
  min-width: 190px;
}
.topic-selector-language-group .language-selector .select-icon-group {
  border: none;
  width: 100%;
}
.topic-selector-language-group .topic-selector-container {
  flex-grow: 1;
}
.topic-selector-language-group .topic-selector-container .topic-selector {
  border-left: none;
}
.topic-selector-language-group .topic-selector-container .topic-selector > div {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TopicSelector/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;AACF;AACE;EACE,sCAAA;AACJ;AAEE;EACE,YAAA;EACA,gBAAA;AAAJ;AAEI;EACE,YAAA;EACA,WAAA;AAAN;AAIE;EACE,YAAA;AAFJ;AAII;EACE,iBAAA;AAFN;AAIM;EACE,YAAA;AAFR","sourcesContent":[".topic-selector-language-group {\n  display: flex;\n  width: 100%;\n  border: 1px solid var(--gray);\n  border-radius: 4px;\n\n  &:focus-within {\n    border-color: var(--color_primary_500);\n  }\n\n  .language-selector {\n    border: none;\n    min-width: 190px;\n\n    .select-icon-group {\n      border: none;\n      width: 100%;\n    }\n  }\n\n  .topic-selector-container {\n    flex-grow: 1;\n\n    .topic-selector {\n      border-left: none;\n\n      &>div {\n        border: none;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
